import { jsx as o, jsxs as b } from "react/jsx-runtime";
import { I as x, c as w } from "./Section-DOeCOW54.js";
import { useState as d, useRef as S, useEffect as u } from "react";
import { g as C, r as g, s as k } from "./MapView-C6gXpjuJ.js";
import { T as y } from "./useMediaQuery-BZAMobKw.js";
const f = {
  "sort-option": "elo-sort-option",
  "sort-option__label": "elo-sort-option__label"
}, E = ({ label: r, onClick: s }) => /* @__PURE__ */ o("button", { type: "button", className: f["sort-option"], onClick: s, children: /* @__PURE__ */ o(y, { type: "span", size: "small", extraClass: f["sort-option__label"], children: r }) }), l = {
  "sort-by": "elo-sort-by",
  "sort-by__label": "elo-sort-by__label",
  "sort-by__options": "elo-sort-by__options",
  "sort-by__options--open": "elo-sort-by__options--open"
}, z = ({
  label: r,
  options: s = [],
  onChange: v,
  sortByOptionsSessionStorageKey: t,
  defaultOptionValue: i
}) => {
  const [n, a] = d(!1), [m, p] = d(
    () => s.find((e) => e.value === i) ?? null
  ), c = S(null), h = (e) => {
    p(e), v(e), a(!1), e.value === "default" ? g(t) : k(t, e);
  }, _ = (e) => {
    c.current && !c.current.contains(e.target) && a(!1);
  };
  return u(() => {
    const e = C(
      t
    );
    if (e) {
      p(e);
      return;
    }
  }, [i, s, t]), u(() => (document.addEventListener("mousedown", _), () => {
    document.removeEventListener("mousedown", _);
  }), []), /* @__PURE__ */ b(
    "div",
    {
      className: l["sort-by"],
      ref: c,
      onClick: () => a(!n),
      children: [
        /* @__PURE__ */ b(y, { type: "span", size: "small", extraClass: l["sort-by__label"], children: [
          r,
          ": ",
          m ? m.label : "",
          /* @__PURE__ */ o(x, { name: n ? "ArrowUp" : "ArrowDown" })
        ] }),
        /* @__PURE__ */ o(
          "ul",
          {
            className: w(l["sort-by__options"], {
              [l["sort-by__options--open"]]: n
            }),
            children: s.map((e) => /* @__PURE__ */ o("li", { children: /* @__PURE__ */ o(
              E,
              {
                label: e.label,
                onClick: () => h(e)
              }
            ) }, e.value))
          }
        )
      ]
    }
  );
};
export {
  z as S
};
